export default class {
  company_user_id = null;
  name = null;
  surname = null;
  email = null;
  birth_date = null;
  document_number = null;
  phone = null;
  id = null;
  defaultCostCentre = null;
  costCentres = [];
}

export function cleanUserModel(object) {
  object.company_user_id = null;
  object.name = null;
  object.surname = null;
  object.email = null;
  object.birth_date = null;
  object.document_number = null;
  object.phone = null;
  object.id = null;
  object.defaultCostCentre = null;
  object.costCentres = [];
  return object;
}
